/* eslint-disable react/style-prop-object */

const TesteSharePoint = () => {
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 flex flex-col justify-center items-center">
        <iframe
          title="teste"
          src="https://banco365.sharepoint.com/sites/AprendaMicrosoft365/_layouts/15/embed.aspx?UniqueId=a4ecd2c4-a421-48ea-8e62-723e115c65cf&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create%22"
          style={{ width: '100%', maxWidth: '800px', height: '250px', border: 'none' }}
          allowFullScreen
        ></iframe>

        <iframe
          title="teste"
          src="https://banco365.sharepoint.com/sites/NovoJogaJuntoBB/_layouts/15/embed.aspx?UniqueId=37bb91eb-69d7-407c-9960-44b99c13c0d4&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create%22"
          style={{ width: '100%', maxWidth: '800px', height: '250px', border: 'none' }}
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default TesteSharePoint;
